export const UPDATE_DOWNLOAD_STATUS = 'update_download_status ';